import type { Paragraph } from '@/api/types/stowed-element'
import type { AlignmentUiValue } from '../types/alignment-ui-value'

export function alignmentToUiValue(alignment?: number): AlignmentUiValue {
  if (alignment === 1) return 'center'
  if (alignment === 2) return 'right'
  if (alignment === 3) return 'justify'

  return 'left'
}

export function alignmentToNumeric(uiValue: string): number {
  if (uiValue === 'center') return 1
  if (uiValue === 'right') return 2
  if (uiValue === 'justify') return 3

  return 0
}

export function resolveUniformAlignment(
  paragraphs: Paragraph[] | undefined
): AlignmentUiValue | null {
  if (!paragraphs || paragraphs.length === 0) return null

  let firstValue: AlignmentUiValue | null = null

  for (const paragraph of paragraphs) {
    const normalized = alignmentToUiValue(paragraph.alignment)

    if (firstValue == null) {
      firstValue = normalized
      continue
    }

    if (firstValue !== normalized) {
      return null
    }
  }

  return firstValue
}
